import Axios             from 'axios';
import { doWithRetries } from '$/lib/utils';

import { Entity } from '$/entities/BaseEntity';

import { TenantCheck as TenantCheckCommon } from '$/common/entities/tenantScreening/TenantCheck';
export * from '$/common/entities/tenantScreening/TenantCheck';

@Entity()
export class TenantCheck extends TenantCheckCommon {

	async isReportAvailable() {
		return doWithRetries(
			async () => (await Axios.get((this.constructor as typeof TenantCheck).collectionUrl(`/${this.id}/report-availability`))).data,
			{
				retries          : 6,
				retryDelay       : 100,
				exponentialDelay : true,
				errorMessage     : 'report not available',
			}
		);
	}

}

